export default __webpack_public_path__ + "static/media/Seccion_promos_pasada_28_agosto.8e0fe2b3.webp";